/* =====================================================================
   DANSKO COLOUR SWATCHES (product cards + Quick Shop)
   AU colours are separate products titled "Dansko <Style>-<Colour>".
   This finds a style's colours with one request to
   /search?q=<Dansko Style>&type=product&view=dkswatch  (templates/search.dkswatch.liquid)
   and caches the result for the browser session.
   Clicking a colour switches the card (photo, colour, price, links, Quick Shop) in place.
   Swatch look, in order of preference:
     1. product metafield custom.swatch_image
     2. product metafield custom.swatch_color (e.g. #563d2e)
     3. a colour guessed from the colour name (Black, Honey, Navy ...)
     4. a close-up crop of the product photo
   ===================================================================== */
(function () {
  'use strict';

  var MAX_DOTS = 5;
  var root = ((window.dkQuickShop && window.dkQuickShop.rootUrl) || '/').replace(/\/$/, '');
  var memory = {};

  var NAMED = [
    [/black|onyx|charcoal/, '#1c1c1c'], [/white|ivory|cream|bone/, '#f3efe6'],
    [/navy|indigo/, '#23304a'], [/denim|chambray|blue/, '#4f6f95'],
    [/red|cherry/, '#9b2c2c'], [/burgundy|wine|mulberry|oxblood|cordovan/, '#5e1f2b'],
    [/pink|blush|rose/, '#e6b8bd'], [/purple|plum|lilac/, '#6f4e7c'],
    [/green|olive|evergreen|sage|moss/, '#4f5b3a'], [/yellow|mustard/, '#d7a93d'],
    [/orange|rust/, '#b5562a'], [/gold/, '#c9a44c'], [/silver|pewter|metallic/, '#b9b9b9'],
    [/grey|gray|slate|smoke/, '#8a8a8a'], [/taupe|stone|sand|khaki|beige|oat|natural/, '#c9b79c'],
    [/honey|tan|saddle|camel|cognac|caramel/, '#b5793e'],
    [/brown|chocolate|espresso|mocha|antique|walnut|oiled/, '#5c3b28']
  ];

  function styleOf(title) {
    var i = title.indexOf('-');
    return i > -1 ? { query: title.slice(0, i).trim(), prefix: title.slice(0, i + 1).toLowerCase() } : null;
  }

  function colourOf(title) {
    var i = title.indexOf('-');
    return i > -1 ? title.slice(i + 1).trim() : title;
  }

  function guess(name) {
    var n = String(name).toLowerCase();
    if (/leopard|floral|embroider|print|tooled|plaid|multi|glitter|haircalf|patchwork/.test(n)) return null;
    for (var k = 0; k < NAMED.length; k++) if (NAMED[k][0].test(n)) return NAMED[k][1];
    return null;
  }

  function get(title) {
    var s = styleOf(title || '');
    if (!s) return Promise.resolve([]);
    if (memory[s.prefix]) return memory[s.prefix];
    var key = 'dksw2:' + s.prefix;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < 30 * 60 * 1000) {
        memory[s.prefix] = Promise.resolve(cached.list);
        return memory[s.prefix];
      }
    } catch (e) {}
    var url = root + '/search?q=' + encodeURIComponent(s.query) + '&type=product&view=dkswatch&options%5Bprefix%5D=last';
    memory[s.prefix] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var data = JSON.parse(txt);
        var list = (data.products || []).filter(function (p) {
          return p.title.toLowerCase().indexOf(s.prefix) === 0;
        });
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), list: list })); } catch (e) {}
        return list;
      })
      .catch(function () { return []; });
    return memory[s.prefix];
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function dot(p, active) {
    var name = colourOf(p.title);
    var inner;
    if (p.swatch_image) {
      inner = '<img src="' + esc(p.swatch_image) + '" alt="" loading="lazy">';
    } else {
      var hex = p.swatch_color || guess(name);
      inner = hex
        ? '<span class="dk-sw__fill" style="background:' + esc(hex) + '"></span>'
        : '<span class="dk-sw__fill dk-sw__fill--photo" style="background-image:url(' + esc(p.thumb || p.image) + ')"></span>';
    }
    return '<a class="dk-sw' + (active ? ' is-active' : '') + (p.available === false ? ' is-soldout' : '') + '" href="' + esc(p.url) +
      '" data-handle="' + esc(p.handle) + '" title="' + esc(name) + '" aria-label="' + esc(name) + '"' +
      (active ? ' aria-current="true"' : '') + '>' + inner + '</a>';
  }

  function render(el, list) {
    var handle = el.getAttribute('data-handle');
    var current = list.filter(function (p) { return p.handle === handle; })[0];
    if (!current) {
      current = { handle: handle, title: el.getAttribute('data-title') || '', url: el.getAttribute('data-url') || '#', image: null, thumb: el.getAttribute('data-thumb') };
    }
    var others = list.filter(function (p) { return p.handle !== handle; });
    var all = [current].concat(others);
    var shown = all.slice(0, MAX_DOTS);
    var extra = all.length - shown.length;
    el.innerHTML = shown.map(function (p, i) { return dot(p, i === 0); }).join('') +
      (extra > 0 ? '<a class="dk-sw__more" href="' + esc(current.url) + '">+' + extra + '</a>' : '');
    el.classList.add('is-ready');

    var card = el.closest('.card-wrapper, .dk-card');
    if (!card) return;
    var byHandle = {};
    all.forEach(function (p) { byHandle[p.handle] = p; });

    /* Hovering the swatch row must not trigger the card's second-image hover */
    el.addEventListener('mouseenter', function () { card.classList.add('dk-sw-hover'); });
    el.addEventListener('mouseleave', function () { card.classList.remove('dk-sw-hover'); });

    /* Click a colour: switch this card to that product */
    el.addEventListener('click', function (e) {
      var a = e.target.closest('.dk-sw');
      if (!a) return;
      var h = a.getAttribute('data-handle');
      var p = byHandle[h];
      if (!p || !p.image) return;            /* no data: let the link open the product */
      e.preventDefault();
      e.stopPropagation();
      if (a.classList.contains('is-active')) return;
      switchCard(card, el, p);
      el.querySelectorAll('.dk-sw').forEach(function (d) {
        var on = d === a;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      var more = el.querySelector('.dk-sw__more');
      if (more) more.setAttribute('href', p.url);
    });
  }

  function setImg(img, src) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
  }

  function switchCard(card, el, p) {
    var colour = colourOf(p.title);
    /* photos */
    var main = card.querySelector('.card__media .media > img, .dk-card__img');
    var second = card.querySelector('.card__media .media > img:nth-of-type(2), .dk-card__img2');
    setImg(main, p.image);
    if (second) {
      if (p.image2) { setImg(second, p.image2); second.style.display = ''; }
      else { second.style.display = 'none'; }
    }
    if (main) main.setAttribute('alt', p.title);
    /* text */
    var col = card.querySelector('.dansko-card-description, .dk-card__colour');
    if (col) col.textContent = colour;
    var price = card.querySelector('.dansko-card-price, .dk-card__price');
    if (price && p.price) {
      price.classList.toggle('dansko-card-price--sale', !!p.compare_at);
      price.classList.toggle('dk-card__price--sale', !!p.compare_at);
      price.innerHTML = (p.price_varies ? 'From ' : '') + esc(p.price) + (p.compare_at ? ' <s>' + esc(p.compare_at) + '</s>' : '');
    }
    /* links */
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.closest('.dk-swatches')) return;
      if (/\/products\//.test(a.getAttribute('href'))) a.setAttribute('href', p.url);
    });
    /* quick shop */
    var qs = card.querySelector('[data-dk-quick-shop]');
    if (qs) {
      qs.setAttribute('data-dk-quick-shop', p.handle);
      qs.disabled = p.available === false;
      var label = qs.querySelector('span');
      if (label) label.textContent = p.available === false ? ((window.dkQuickShop && window.dkQuickShop.soldOut) || 'Sold out') : 'Quick Shop';
    }
    el.setAttribute('data-handle', p.handle);
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll('[data-dk-swatches]:not([data-dk-sw-bound])');
    if (!els.length) return;
    var run = function (el) {
      get(el.getAttribute('data-title')).then(function (list) { render(el, list); });
    };
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-dk-sw-bound', ''); run(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); run(en.target); }
      });
    }, { rootMargin: '400px 0px' });
    els.forEach(function (el) { el.setAttribute('data-dk-sw-bound', ''); io.observe(el); });
  }

  window.DanskoSwatches = { get: get, init: init, colourOf: colourOf };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Collection filtering / sorting / infinite load swaps the grid: bind new cards */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
